import { jsx as _jsx } from "react/jsx-runtime";
export const Logo = ({ src, width, }) => {
    return (_jsx("img", { alt: "Flormorado Caf\u00E9", src: src, width: width, className: "d-inline-block align-top" }));
};
